import React, { useEffect, useRef, useState } from "react";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  USERCOURSES,
  USERLESSON,
  LESSONDETAIL,
  ACCESS_DENIED,
} from "../../../constant/routeContant";
import UserLessonsList from "../component/userLessonsList/userLessonsList";
import * as lmsAction from "../../../redux/actions/lmsAction";
import * as lmsUserAction from "../../../redux/actions/lmsUserAction";
import { useDispatch, useSelector } from "react-redux";
import {
  API_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  USER_ID,
} from "../../../constant/constant";
import { useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { useLocation } from "react-router-dom";
import Loader from "../../../library/common/Loader";
import { InactiveClient, getUserBaseDivisionInfo } from "../../../utils/helper";
import { toast, ToastContainer } from "react-toastify";

const UserLessonsContainer = () => {
  const dispatch = useDispatch();
  const PAGE_SIZE = 6;
  const lessionUserListData = useSelector((state) => state.getUserLessonsList);
  const location = useLocation();
  const islesson = location?.state?.islesson;
  const isClientSwitch = parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID());

  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const categoryUserListData = useSelector(
    (state) => state.getCategoryList?.data,
  );

  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };
  let navigate = useNavigate();
  const defaultData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    statusId: 2,
    userId: isClientSwitch ? 0 : USER_ID(),
    orgId: ORG_ID(),
    divisionId: 0,
    isSendMail: false,
  };
  const [islessonId, setislessonId] = useState(null);
  const [isstart, setisstart] = useState(false);

  const startLessonData = useSelector((state) => state.startLesson);
  const showStartLoader = useSelector((state) => state.startLesson?.isLoading);
  const showLoader = useSelector((state) => state.getCategoryList?.isLoading);

  const initRef = useRef(
    (() => {
      const shouldPreserve =
        sessionStorage.getItem("lmsLessonsPreserveState") === "true";
      if (!shouldPreserve) return null;
      try {
        return JSON.parse(
          sessionStorage.getItem("lmsLessonsFilterObj") || "null",
        );
      } catch {
        return null;
      }
    })(),
  );
  const hasFiredRef = useRef(false);

  const getLessionUserListData = (data) => {
    const payload = {
      ...data,
      divisionId: data?.divisionId ?? 0,
    };
    dispatch(lmsUserAction.getUserLessonsList(payload));
    dispatch(lmsUserAction.getUserLessonsListFilterObj(payload));
  };

  useEffect(() => {
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;

    const isAllowedDash = checkPrivileges([12, 11, 10, 9]);
    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }

    const savedFilter = initRef.current;

    if (!savedFilter) {
      dispatch(lmsUserAction.getUserLessonsListFilterObj(defaultData));
      getLessionUserListData(defaultData);
    } else {
      const restoreData = {
        ...defaultData,
        pageNumber: savedFilter.page != null ? savedFilter.page + 1 : 1,
        search: savedFilter.search || "",
        catIds: savedFilter.selectedValue || "",
        statusId:
          savedFilter.value === 0
            ? 2
            : savedFilter.value === 2
              ? ""
              : savedFilter.value === 1
                ? 1
                : 2,
      };
      getLessionUserListData(restoreData);
    }
    dispatch(lmsAction.clearCategoryList());
  }, []);
  useEffect(() => {
    if (
      startLessonData.status === API_STATUS.SUCCESS &&
      (islesson || isstart)
    ) {
      navigate(LESSONDETAIL, {
        state: { lessonId: islessonId },
      });
    }
  }, [startLessonData, islesson]);

  const dataHeader = {
    title: "My Training",
    menu: [
      {
        route: USERLESSON,
        text: "Lessons",
      },
      {
        route: USERCOURSES,
        text: "Courses",
      },
    ],
  };
  const isLoading = useSelector((state) => state.getUserLessonsList?.isLoading);
  const postunEnrollLesson = (data) => {
    if (InactiveClient()) return;
    dispatch(lmsAction.unEnrollLesson(data));
  };

  return (
    <>
      {((showStartLoader && isstart) || showLoader) && <Loader />}

      <LmsHeader dataHeader={dataHeader} />
      <ToastContainer />
      <UserLessonsList
        lessionUserListData={lessionUserListData.data}
        getLessionUserListData={getLessionUserListData}
        categoryUserListData={categoryUserListData}
        isLoading={isLoading}
        isShow={true}
        islessonId={islessonId}
        setislessonId={setislessonId}
        setisstart={setisstart}
        postunEnrollLesson={postunEnrollLesson}
        showDownloadButton={false}
        isAllTab={true}
        getategoryListData={getategoryListData}
        lessionUserListDataset={lessionUserListData}
        isClientSwitch={isClientSwitch}
      />
    </>
  );
};

export default UserLessonsContainer;
